import { useDispatch, useSelector } from "react-redux";
import {
  preflightAssignmentsRefreshed,
  selectPreflightAssignmentsChanged,
} from "../../reducers/flightSlice";
import {
  getTournament,
  selectCurrentTournament,
} from "../../reducers/tournamentSlice";
import { useNavigate } from "react-router-dom";
import { GSItemInfo } from "golfstatus_react_components";
import {
  faCircleExclamation,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { useNotificationBanner } from "../notificationHooks";

//the tournament says whether any team has a flight, but only as of when it was
//loaded, so it's loaded again once flights change. the store is checked rather
//than the hook's copy, since more than one page on screen can be asking.
const refreshPreflightAssignments = (tournamentID) => (dispatch, getState) => {
  if (!selectPreflightAssignmentsChanged(getState())) {
    return;
  }
  dispatch(preflightAssignmentsRefreshed());
  dispatch(getTournament(tournamentID));
};

export const usePreflighting = ({
                                  tournamentID,
                                  notificationSettings = {},
                                }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentTournament = useSelector(selectCurrentTournament);
  const assignmentsChanged = useSelector(selectPreflightAssignmentsChanged);

  useEffect(() => {
    if (assignmentsChanged && tournamentID) {
      dispatch(refreshPreflightAssignments(tournamentID));
    }
  }, [dispatch, assignmentsChanged, tournamentID]);

  //a pre-flighted event none of whose teams have been placed in a flight yet
  const showFlightingBanner =
    !!currentTournament?.preflight &&
    currentTournament?.hasPreflightAssignments === false;

  const navigateToFlights = () => {
    navigate(`/${tournamentID}/flighting`);
  };

  const flightWarningBanner = () => {
    const bannerActions = [
      {
        buttonTitle: "Edit Flights",
        buttonIcon: faPencil,
        size: "primary",
        type: "navigation orange",
        actionClick: navigateToFlights,
      },
    ];
    return {
      title: (
        <GSItemInfo
          icon={faCircleExclamation}
          header="Incomplete Pre-Flight Assignments"
          value="Leaderboards won't display scores until players & teams are assigned to flights."
        ></GSItemInfo>
      ),
      bannerActions: bannerActions,
      type: "warning",
    };
  };

  const settings = {
    ...notificationSettings,
    defaultBanner: showFlightingBanner ? flightWarningBanner() : notificationSettings?.defaultBanner,
  };

  const [bannerNotifications] = useNotificationBanner(settings);

  const getBanner = () => {
    return  bannerNotifications;
  };

  return {
    showFlightingBanner,
    getBanner,
  };
};
